<ion-card>
  <ion-card-header>
    <ion-card-title>Jogkör-hozzárendelés</ion-card-title>
    <ion-card-subtitle>Ki milyen szerepkörrel dolgozik — egy helyen, kereshetően</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="jk-bevezeto">
      A jogkör dönti el, mit lát és mit tehet valaki a rendszerben. Eddig ez csak az
      állomány-adatlapon volt szerkeszthető, emberenként és alrendszer nélkül<ng-container *ngIf="sulinform"> — a
      gondviselőknél pedig sehogy</ng-container>. A módosítás <b>azonnal érvényes</b>, és a kiszolgáló
      minden változást naplóz: ki, kinek, miről mire.
    </ion-note>

    <div class="jk-fejlec">
      <!-- Egyetlen kör (az iskolán kívül csak a dolgozói: munkatárs és ügyfél) – nincs mit választani. -->
      <ion-segment *ngIf="fajtak.length > 1" [value]="fajta" (ionChange)="fajtaValt($event.detail.value)">
        <ion-segment-button *ngFor="let f of fajtak" [value]="f.fajta">
          <ion-label>{{ f.nev }}</ion-label>
        </ion-segment-button>
      </ion-segment>
      <ion-input label="Keresés" label-placement="stacked" fill="outline"
                 placeholder="név, azonosító, jogkör…" [(ngModel)]="szuro"></ion-input>
      <ion-item lines="none" *ngIf="fajta === 'dolgozo'">
        <ion-toggle [(ngModel)]="csakKilepettNelkul" labelPlacement="start">
          Kilépettek elrejtése
        </ion-toggle>
      </ion-item>
    </div>

    <div class="jk-allapot" *ngIf="toltodik">
      <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
    </div>
    <div class="jk-allapot hiba" *ngIf="!toltodik && hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>

    <ng-container *ngIf="!toltodik && !hiba">
      <!-- TÖMEGES MŰVELET. Egy jogkör kiosztása tíz embernek egyenként tíz adatlap. -->
      <div class="jk-tomeges" *ngIf="kijelolt.size">
        <div class="jk-tomeges-cim"><b>{{ kijelolt.size }}</b> kijelölve</div>
        <ion-select label="Alrendszer" labelPlacement="stacked" interface="popover"
                    [(ngModel)]="tomegesAlrendszer" (ngModelChange)="tomegesJogkor = ''">
          <ion-select-option *ngFor="let a of alrendszerek" [value]="a.alrendszer">{{ a.alrendszer }}</ion-select-option>
        </ion-select>
        <ion-select label="Jogkör" labelPlacement="stacked" interface="popover"
                    placeholder="válassz…" [(ngModel)]="tomegesJogkor">
          <ion-select-option *ngFor="let j of tomegesJogkorok" [value]="j.jogkor">
            {{ j.name }}{{ j.admin ? ' ★' : '' }}
          </ion-select-option>
        </ion-select>
        <ion-button size="small" color="success" [disabled]="!tomegesJogkor || ment"
                    (click)="tomeges('hozzaad')">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Hozzáadás
        </ion-button>
        <ion-button size="small" color="danger" fill="outline" [disabled]="!tomegesJogkor || ment"
                    (click)="tomeges('elvesz')">
          <ion-icon slot="start" name="remove-circle-outline"></ion-icon>Elvétel
        </ion-button>
      </div>

      <div class="jk-ures" *ngIf="!szurtTetelek.length">
        Nincs a szűrésnek megfelelő találat.
      </div>

      <div class="jk-tabla-burok" *ngIf="szurtTetelek.length">
        <table class="jk-tabla">
          <thead>
            <tr>
              <th class="jk-pipa">
                <ion-checkbox (ionChange)="mindKijelol()" aria-label="Mind kijelölése"></ion-checkbox>
              </th>
              <th>Név</th>
              <th>Azonosító</th>
              <th>Jogkörök</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of szurtTetelek" [class.kilepett]="t.kilepett">
              <td class="jk-pipa">
                <ion-checkbox [checked]="kijeloltE(t)" (ionChange)="kijelolValt(t)"
                              [attr.aria-label]="t.nev"></ion-checkbox>
              </td>
              <td>
                <b>{{ t.nev }}</b>
                <span class="jk-alcim" *ngIf="t.megjegyzes">{{ t.megjegyzes }}</span>
                <span class="jk-alcim jk-kilepett" *ngIf="t.kilepett">kilépett</span>
              </td>
              <td class="jk-azonosito">{{ t.azonosito }}</td>
              <td>
                <span class="jk-chip" *ngFor="let j of jogkorLista(t)"
                      [class.admin]="j.admin" [class.ismeretlen]="ismeretlen(j.alrendszer, j.jogkor)"
                      [title]="j.alrendszer + ' · ' + j.jogkor">
                  <span class="jk-alr" *ngIf="j.alrendszer !== 'SULINFORM'">{{ j.alrendszer }}</span>
                  {{ j.nev }}
                </span>
                <span class="jk-nincs" *ngIf="!jogkorLista(t).length">nincs jogköre</span>
              </td>
              <td class="jk-muvelet">
                <ion-button size="small" fill="clear" (click)="szerkesztoNyit(t)">Szerkesztés</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ion-note color="medium" class="jk-labjegyzet">
        A <b>★</b> azt jelöli, hogy a jogkör a jogkör-kezelőben adminnak van jelölve.
        A <span class="jk-chip ismeretlen">így jelölt</span> jogkör kódja nincs benne a
        jogkör-törzsben — régi vagy elgépelt érték; a rendszer nem ismeri fel, de nem is
        dobja el csendben.
      </ion-note>
    </ng-container>
  </ion-card-content>
</ion-card>

<!-- ── Egyéni szerkesztő ──────────────────────────────────────────────────── -->
<ion-modal [isOpen]="!!szerkesztett" (didDismiss)="szerkesztoZar()">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ szerkesztett?.nev }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="szerkesztoZar()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        Azonosító: <b>{{ szerkesztett?.azonosito }}</b><span *ngIf="szerkesztett?.feladatellatas">,
        feladatellátás: <b>{{ szerkesztett?.feladatellatas }}</b></span>. A jogkör a
        <b>feladatellátáshoz</b> tartozik, nem az emberhez: ugyanaz a kolléga más
        intézményben más szerepben dolgozhat.
      </ion-note>

      <div class="jk-alrendszer" *ngIf="egyebJogkorok.length">
        <h3>Egyéb (a jogkör-törzsben nem szerepel)</h3>
        <p class="jk-egyeb-sugo">
          Régi vagy elgépelt kód, illetve olyan alrendszeré, aminek nincs jogkör-törzse.
          A mentés <b>megtartja</b> őket — de ha nem kellenek, itt kivehetők.
        </p>
        <span class="jk-chip ismeretlen jk-egyeb" *ngFor="let e of egyebJogkorok">
          <span class="jk-alr">{{ e.alrendszer }}</span>{{ e.jogkor }}
          <ion-icon name="close-circle" (click)="egyebElvesz(e.alrendszer, e.jogkor)"
                    title="Elvétel"></ion-icon>
        </span>
      </div>

      <div class="jk-alrendszer" *ngFor="let a of alrendszerek">
        <h3>{{ a.alrendszer }}</h3>
        <div class="jk-valaszto">
          <ion-item lines="none" *ngFor="let j of a.jogkorok">
            <ion-checkbox [checked]="vanBejelolve(a.alrendszer, j.jogkor)"
                          (ionChange)="bejelolValt(a.alrendszer, j.jogkor)"
                          labelPlacement="end">
              {{ j.name }}<span class="jk-kod">{{ j.jogkor }}</span>
              <span class="jk-admin-jel" *ngIf="j.admin">admin</span>
            </ion-checkbox>
          </ion-item>
        </div>
      </div>
    </ion-content>

    <ion-footer class="jk-labjegyzetsav">
      <ion-toolbar>
        <div class="jk-gombsor">
          <ion-button fill="outline" (click)="szerkesztoZar()">Mégse</ion-button>
          <ion-button color="primary" [disabled]="ment" (click)="szerkesztoMent()">
            <ion-icon slot="start" name="save"></ion-icon>
            {{ ment ? 'Mentés…' : 'Mentés' }}
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
